var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Goods',{ref:"goods"}),_c('Demand',{ref:"demand"}),_c('ReceiveOrderLog',{ref:"receiveOrderLog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }